<template>
    <div class='component-page'>
        <!--文本搜索位置-->
        <div class="filter-area">
            <Row style='text-align: center;' class='add_search'>
                <Col span="4">
                    <Input search v-model="formItem.sys_order_num" placeholder="输入订单号" @on-search="handleSearch" style="width:100%;" />
                </Col>
               
            </Row>
        </div>
        <!--下拉搜索位置-->
        <div class="edittable-table-height-con">
            <Row class='search-select'>
                <Col span="8">
                    <span>时间：</span>
                    <Date-picker type="date" placeholder="选择日期" v-model='start_time' style="width: 130px;display:inline-block" @on-change='changStarttime'></Date-picker>
                    <span style="margin: 0 10px;">至</span>
                    <Date-picker type="date" placeholder="选择日期" v-model='end_time' style="width: 130px;display:inline-block" @on-change='changEndtime'></Date-picker>
                </Col>
                <Col span='4'>
                    <Select v-model="formItem.pay_status" placeholder="订单状态" @on-change="handleSearch" clearable style="width:200px">
                        <Option v-for="item in statusList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>
                </Col>
            </Row>
            <Table stripe border :columns="editIncellColumns" :data="editIncellData"></Table>
            <div style="margin: 20px 0 10px 0 ;overflow: hidden;">
                <Page style='float: right'  size="small" :total="total_count" :page-size="formItem.page_size" :current="formItem.page" @on-change="changePage" />
            </div>
        </div>
    
      
    </div>
</template>

<style lang="css">
    @import "../common.css";
</style>
<script>
    import {
        fetchTableList,
    
      
    } from '@/api/schoolOrder'

    export default {
        name: 'user-components',
        data () {
            return {
                total_count: 0, //列表总条数
                formItem:{
                    page: 1, //列表当前页数
                    page_size: 10,
                    sys_order_num: '', 
                    start_time: '',
                    end_time: '',
                    pay_status: '',
                    school_id: '',
                },
                start_time: '',
                end_time: '',
                schoolData:[],
                provinceList:[],
                cityList:[],
                areaList:[],
                statusList:[
                    {id:1,name:'已支付'},
                    {id:0,name:'未支付'},
                ],
                editIncellColumns: [
                    {
                        title: '序号',
                        align: 'center',
                        type: 'index',
                        width: 80,
                    },
                
                    {
                        title: '订单号',
                        align: 'center',
                        key: 'sys_order_num',

                    },
                    {
                        title: '校区名称',
                        align: 'center',
                        key: 'school_name',
                    },
                  
                    {
                        title: '下单时间',
                        align: 'center',
                        key: 'create_at',
                        width:150,
                    },
                    {
                        title: '支付时间',
                        align: 'center',
                        key: 'pay_at',
                        width: 150,
                    },
                    {
                        title: '订单金额',
                        align: 'center',
                        key: 'money',
                    },
                    {
                        title: '支付状态',
                        align: 'center',
                        key: 'pay_status',
                        render: (h, params) => {
                            if(params.row.pay_status==1){
                                return h('span', '已支付')
                            }else{
                                return h('span', '未支付')
                            }
                        }
                    },
                    //  {
                    //     title: '订单状态',
                    //     align: 'center',
                    //     key: 'status',
                    //     render: (h, params) => {
                    //         if(params.row.status==1){
                    //             return h('span', '正常')
                    //         }else{
                    //             return h('span', '禁用')
                    //         }
                    //     }
                    // },
                
                ],//列表
                editIncellData: [],//列表数据
            };
        },
        methods: {
            //获取列表数据
            getData () {
                this.$Loading.start();
                fetchTableList(this.formItem).then(res => {
                    res=res.data;
                    this.$Loading.finish();
                    if(res.code == 200){
                        this.editIncellData = res.data.list;
                        this.total_count = parseInt(res.data.total_count);
                    }else if(res.code == 14001){
                        this.$Message.error(res.msg);
                        this.$store.dispatch('handleLogOut').then(res => {
                            this.$store.commit('clearOpenedSubmenu')
                            this.$router.push({
                                name: 'login'
                            })
                        })
                    }else{
                        this.$Message.error(res.msg);
                    }
                })
            },
            seeInfo(id){

            },

             // 改变开始时间
            changStarttime(time) {
                if (time == '') {
                    this.formItem.start_time = '';
    
                } else {
                    this.formItem.start_time = new Date(time).getTime() / 1000 - 28800;
                }
                this.formItem.page = 1;
                this.getData();
            },
            // 改变结束时间
            changEndtime(time) {
                if (time == '') {
                    this.formItem.end_time = '';
    
                } else {
                    this.formItem.end_time = new Date(time).getTime() / 1000 + 57600;
                }
                this.formItem.page = 1;
                this.getData();
            },
            // 取消关闭弹层
            cancel(){
                this.addModel=false;
                this.detailsModal=false;
            },
           
            //搜索框搜索
            handleSearch () {
                this.formItem.page = 1;
                this.getData();
            },
            //改变当前页码
            changePage (row) {
                this.formItem.page = row;
                this.getData();
            },
            
        },
        created () {
            this.getData();
        }
    };
</script>
